var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.686.486c1.158.314 2.052 1.198 2.345 2.317.383 2.036.569 4.103.555 6.172a32.233 32.233 0 01-.555 6.08c-.293 1.119-1.187 2.002-2.345 2.316-2.078.533-10.393.533-10.393.533s-8.314 0-10.392-.533c-1.134-.297-2.023-1.14-2.344-2.223A32.223 32.223 0 010 8.975C-.01 6.921.176 4.87.557 2.85.849 1.73 1.743.847 2.9.533 4.979 0 13.294 0 13.294 0s8.314 0 10.392.486zm-6.163 8.49l-6.949 3.787V5.189l6.949 3.787z","fill":"#fff"}));
}

Youtube.defaultProps = {"fill":"none","viewBox":"0 0 27 18"};

module.exports = Youtube;

Youtube.default = Youtube;
